<template>
  <th v-if="isHeader">
    {{ $t('Min Stock') }}
  </th>
  <td v-else>
    <input
      type="number"
      class="form-control form-control-sm min-stock-input"
      :value="rowData.min_stock"
      @blur="updateMinStock($event)"
      @keyup.enter="$event.target.blur()"
      min="0"
      :placeholder="$t('Not set')"
    />
  </td>
</template>

<script>
import VuetableFieldMixin from 'vuetable-2/src/components/VuetableFieldMixin'

export default {
  name: 'vue-table-stock-min-level',
  mixins: [VuetableFieldMixin],
  props: ['rowData', 'rowIndex'],
  methods: {
    async updateMinStock (event) {
      const newValue = event.target.value.trim()
      const minStock = newValue === '' ? null : parseInt(newValue, 10)

      // Skip if value hasn't changed
      if (minStock === this.rowData.min_stock) {
        return
      }

      // Validate: must be null, 0, or positive integer
      if (minStock !== null && (isNaN(minStock) || minStock < 0)) {
        this.$notify({
          group: 'full',
          type: 'error',
          text: this.$t('Min stock must be a positive number or empty')
        })
        event.target.value = this.rowData.min_stock !== null ? this.rowData.min_stock : ''
        return
      }

      try {
        await this.$http.patch(`article/${this.rowData.id}/min-stock`, {
          min_stock: minStock
        })
        this.rowData.min_stock = minStock
        this.$notify({
          group: 'full',
          text: this.$t('Min stock level updated')
        })
      } catch (error) {
        this.$notify({
          group: 'full',
          type: 'error',
          text: this.$t('Failed to update min stock level')
        })
        event.target.value = this.rowData.min_stock !== null ? this.rowData.min_stock : ''
      }
    }
  }
}
</script>

<style scoped>
.min-stock-input {
  width: 80px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// VueTableStockMinLevel.vue?39405bcc